export const warn = (component, ...message) =>
// eslint-disable-next-line no-console
console.warn('@tourlane/tourlane-ui:', `<${component}>:`, ...message);
export const error = (component, ...message) =>
// eslint-disable-next-line no-console
console.error('@tourlane/tourlane-ui:', `<${component}>:`, ...message);

// eslint-disable-next-line no-console
export const log = (...args) => console.log('@tourlane/tourlane-ui:', ...args);